import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Component, EventEmitter, OnInit, SimpleChange } from '@angular/core';
import { AppInjector } from '../app-injector';
import { Gender } from '../enum/gender.enum';
import { AbstractAnalyticsService } from '../services/google-analytics/analytics.abstract.service';
import { AccountTypeEnum, ClaroRoles, DiscoveryStatusEnum, PersonalUserData, UserRole } from '../services/personal-user-data/personal-user-data';
import { PersonalUserDataService } from '../services/personal-user-data/personal-user-data.service';
import { Observable } from 'rxjs';
import { Direction, Directionality } from '@angular/cdk/bidi';
import { Locale } from '../enum/locale.enum';
import { UtilsService } from '../services/utils/utils.service';
// import { TOUCH_BUFFER_MS } from '@angular/cdk/a11y/input-modality/input-modality-detector';
import { AbstractLocalStorageService } from '../services/localStorage/local-storage.abstract.service';
import { LocalStorageKeys } from '../services/localStorage/local-storage.enum';
@Component({ 
  selector: 'app-base',
  template: `
    <p>
    </p>
  `,
  styleUrls: ['./base.component.scss']   
})
export class BaseComponent implements OnInit {
  protected personalUserDataServiceForBaseClass: PersonalUserDataService;
  protected analytics: AbstractAnalyticsService;
  protected isHandHeldDevice: boolean = false;
  protected isMediumBreakpoint : boolean = false;
  private responsive: BreakpointObserver;
  private localBaseStorageService: AbstractLocalStorageService;
  protected utilsService: UtilsService;
  public saveProgressEvent: Observable<void>;
  public dir: Direction;

  constructor() { 
      const injector = AppInjector.getInjector();
      this.personalUserDataServiceForBaseClass = injector.get(PersonalUserDataService); 
      this.analytics = injector.get(AbstractAnalyticsService);
      this.responsive = injector.get(BreakpointObserver);
      this.utilsService = injector.get(UtilsService);
      this.localBaseStorageService = injector.get(AbstractLocalStorageService);
  }

  ngOnInit(): void {
    this.responsive.observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape, Breakpoints.Medium])
      .subscribe((result: BreakpointState) => {

        this.isHandHeldDevice = false; 

        if (result.breakpoints[Breakpoints.HandsetLandscape] || result.breakpoints[Breakpoints.HandsetPortrait]) {
          this.isHandHeldDevice = true;
        }
        if (result.breakpoints[Breakpoints.Medium]){
          this.isMediumBreakpoint = true;
        }

      });
  }

  get gender(): Gender {
    return this.personalUserDataServiceForBaseClass.getLoggedInUserGender();
  }

  get isMale(): boolean {
    return this.user?.gender == Gender.MALE;
  }

  get user(): PersonalUserData | undefined {
    return this.personalUserDataServiceForBaseClass.getLoggedInUserPersonalData();
  }


  get isMobileView(): boolean{
    return this.isHandHeldDevice;
  }

  get isMediumResolutionView(): boolean{
    return this.isMediumBreakpoint;
  }

  get isAuthenticated(): boolean {
    return this.personalUserDataServiceForBaseClass.isUserLoggedIn();
  }

  get isFinishedDiscovery(): boolean {
    return this.user?.discoveryStatus === DiscoveryStatusEnum.DONE;
  }

  get isReseller(): boolean{
    if (this.user == undefined){
      return false;
    }

    return this.user?.isReseller;
  }

  get isAdminRole(): boolean{

    if (this.user == undefined){
      return false;
    }

    // if the user role is bigger than the admin value it is an administrator
    return (this.user.claroRole >= ClaroRoles.ADMINISTRATOR);
  }

  get isManagerRole(): boolean {
    if (this.user?.role == UserRole.MANAGER || this.user?.role == UserRole.HR){
      return true;
    }

    return false;
  }

  // check whether the user is not Basic (Claro Discovery) Tier
  get isRegularTier() : boolean {
    if (this.user?.accountType != AccountTypeEnum.CLARO_DISCOVERY && 
        this.user?.accountType != AccountTypeEnum.THRIVE){
      return true;
    }

    return false;
  }

  get isRTL(): boolean {
    if (!this.user){
      const locale = this.getLocale();
      // if we have no user - see if the user selected a locale.
      if (locale === Locale.he_IL){
        return true;
      }
      else {
        return false;
      }
    }
    else if (this.user.isRTL !== undefined)
      return this.user.isRTL;
    else
      return false;
  }

  getLocale(){
    if (this.user){
      // console.log(`getLocale user FOUND lang is ${this.user.locale}`);
      return this.user.locale;
    }
    else{
      let locale = this.getUserSelectedLocale();
      if (locale == undefined || locale == ""){
        // we have no user, and no locale was selected by the user - go with the browser locale
        locale = this.utilsService.getBrowserLocale();
      }

      // console.log(`getLocale user NOT FOUND lang is ${locale}`);
      return locale;
    }
  }

  getUserSelectedLocale(): string{
    let userSelectedLocale = "";
    try{
      userSelectedLocale = this.localBaseStorageService.get<string>(LocalStorageKeys.userSelectedLocale);
    }
    catch{
      // no user selection for locale was found
      userSelectedLocale = "";
    }

    return userSelectedLocale;
  }

  get pageDir(): Direction {
    return ((this.isRTL ? 'rtl' : 'ltr') as Direction);
  }

  getShortDateFormat(): string {
    if (this.user?.locale == Locale.he_IL){
      return "dd.MM.YY";
    }
    else if (this.user?.locale == Locale.en_US){
      return "MM.dd.YY";
    }

    return "dd.MM.YY";
  }

  ifChanged(prop: SimpleChange,
    callback: (value: any) => void
  ): void {
    if (prop !== undefined && prop.currentValue !== undefined) {
      if (prop.currentValue != prop.previousValue && !prop.firstChange) {
        callback(prop.currentValue);
      }
    }
  }
}
